var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mod-demo-echarts"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('el-card',[_c('div',{staticClass:"chart-box",attrs:{"id":'org_chartBarBox_'+_vm.type}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }